import React, { ReactElement } from 'react';
// TODO: replace with png
import Logo from '../../assets/images/png/swap/swaparoundlogo_white.png';
import { Col } from 'antd/lib/grid';

export const Brand: React.FC = (): ReactElement => (
  <Col className="logo-container" span={24}>
    <img src={Logo} alt="mca-logo" />
  </Col>
);
